import { render, staticRenderFns } from "./SaldoGradeModalManage.vue?vue&type=template&id=ae900ad4&scoped=true"
import script from "./SaldoGradeModalManage.vue?vue&type=script&lang=js"
export * from "./SaldoGradeModalManage.vue?vue&type=script&lang=js"
import style0 from "./SaldoGradeModalManage.vue?vue&type=style&index=0&id=ae900ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae900ad4",
  null
  
)

export default component.exports